var map = {
	"../pages/add-loyalty-card/add-loyalty-card.module": [
		540,
		7
	],
	"../pages/login/login.module": [
		541,
		6
	],
	"../pages/map/map.module": [
		542,
		5
	],
	"../pages/product/product.module": [
		543,
		4
	],
	"../pages/profile/profile.module": [
		544,
		3
	],
	"../pages/reset-password/reset-password.module": [
		545,
		2
	],
	"../pages/shop/shop.module": [
		546,
		1
	],
	"../pages/sign-up/sign-up.module": [
		547,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 261;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 261
// module chunks = 8